// This file is managed by `scripts/sync-addresses.mjs`. Run `bun sync-addresses`
// after each local deploy to refresh it from ../blockpot-contracts' `addresses.json`,
// or pipe a Railway-style CHAINS_CONFIG JSON via `--chains-config-json` for hosted chains.
const LOCAL_ADDRESSES: { [key: string]: `0x${string}` } = {
    playerRegistry: '0xc6e7DF5E7b4f2A278906862b61205850344D4e7d',
    kycRegistry: '0x68B1D87F95878fE05B998F19b66F4baba5De1aed',
    operator: '0xa85233C63b9Ee964Add6F2cffe00Fd84eb32338f',
    operatorRoles: '0x67d269191c92Caf3cD7723F116c85e6E9bf55933',
    referralManager: '0xc3e53F4d16Ae77Db1c982e75a937B9f60FE63690',
    potSeeder: '0x9E545E3C0baAB3E08CdfD552C960A1050f373042',
    draw: '0x2279B7A0a67DB372996a5FaB50D91eAA73d2eBe6',
    quickGame: '0x8A791620dd6260079BF849Dc5567aDC3F2FdC318',
}

export default LOCAL_ADDRESSES
